<template>
  <div>
    <va-button @click="getSvcBls" style="white-space: nowrap;">export csv</va-button>
    <va-data-table :fields="fields" :data="reports" :loading="isLoadReports">
      <!-- <template slot="status" slot-scope="props">
        {{}}
      </template> -->
      <template slot="actions" slot-scope="props">
        <!-- <va-select
          :options="statuses.map(el=> {el.report = props.rowData.id; return {...el}})"
          @input="changeStatus"
          :value="statusReport(props.rowData)"
          textBy="title"
          keyBy="status"
          :loading="loadingItems.includes(props.rowData.id)"
          :noClear="true"
        ></va-select> -->

        <router-link :to="{name: 'bls-single', params: {id: props.rowData.id}}"><va-button>{{ $t('bls.more') }}</va-button></router-link>
      </template>

      <template slot="lender" slot-scope="props">
        <router-link :to="{name: 'user-single', params: {id: props.rowData.lender.id}}">{{ props.rowData.lender.get_full_name }}</router-link>
      </template>

      <template slot="borrower" slot-scope="props">
        <router-link :to="{name: 'user-single', params: {id: props.rowData.borrower.id}}">{{ props.rowData.borrower.get_full_name }}</router-link>
      </template>

      <template slot="publication" slot-scope="props">
        <router-link :to="{name: 'publications-single', params: {id: props.rowData.publication.id}}">{{ props.rowData.publication.title }}</router-link>
      </template>

      <template slot="created_at" slot-scope="props">
        <div>{{moment(props.rowData.created_at).format('l')}}</div>
      </template>
      <template slot="price" slot-scope="props">
        <div>{{props.rowData.bls_price}}$</div>
      </template>
    </va-data-table>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      isLoadReports: true,
      statuses: [
        {
          status: 1,
          title: this.$t('bls.status.1'),
        },
        {
          status: 2,
          title: this.$t('bls.status.2'),
        },
        {
          status: 3,
          title: this.$t('bls.status.3'),
        },
      ],
      loadingItems: [],
    }
  },
  computed: {
    ...mapState({
      reports: state => state.Bls.reports,
    }),
    fields() {
      return [
        {
          name: 'id',
          title: this.$t('bls.id'),
        },
        {
          name: '__slot:lender',
          title: this.$t('bls.lenderFullName'),
        },
        {
          name: '__slot:borrower',
          title: this.$t('bls.borrowerFullName'),
        },
        {
          name: '__slot:publication',
          title: this.$t('publication'),
        },
        {
          name: '__slot:created_at',
          title: 'created',
        },
        {
          name: '__slot:price',
          title: 'price',
        },
        {
          name: 'bls_charged',
          title: 'charged',
        },
        {
          name: '__slot:status',
        },
        {
          name: '__slot:actions',
        },
      ]
    },
  },
  methods: {
    ...mapActions('Bls', ['fetchReports', 'getSvcBls']),
    statusReport({ status, id }) {
      return this.statuses?.find(e => e?.status === status) ?? ''
    },
    moment,
    changeStatus({ report, status }) {
      this.loadingItems.push(report)

      setTimeout(() => { this.loadingItems = this.loadingItems.filter(e => e !== report) }, 5000)
    },
  },
  async created() {
    await this.fetchReports()
    this.isLoadReports = false
  },
}
</script>
